import React, { useState } from "react";
import SecondaryHeading from "../../../components/common/Typography/SecondaryHeading";
import Paragraph from "../../../components/common/Typography/Paragraph";
import FieldDropdown from "../../../components/common/InputField/FieldDropdown";
import GeneralInquiry from "./GeneralInquiry";
import {
  PUBLIC_HEADING_TO_BODY_CLASS,
  PUBLIC_HEADING_TO_CONTENT_COMPACT_CLASS,
  PUBLIC_HEADING_TO_CONTENT_CLASS,
} from "../../Public/shared/publicLayoutSpec";

const ContactUSForms = () => {
  const [selectedReason, setSelectedReason] = useState(null);
  const forms = [
    { name: "General inquiry" },
    { name: "Billing questions" },
    { name: "Technical support" },
    { name: "Feedback & suggestions" },
    { name: "Account issues" },
    { name: "Other" },
  ];

  return (
    <>
      <div className="mx-[10%] sm:mx-auto w-[400px] sm:w-[400px] md:w-[480px] xl:max-w-field-page-md xl:w-full">
        <SecondaryHeading variant={"MainParagraphHeading"} className="text-center">
          Questions, comments, or concerns?
        </SecondaryHeading>
        <Paragraph variant={"MainParagraph"} className={`text-center ${PUBLIC_HEADING_TO_BODY_CLASS}`}>
          Feel free to reach out.
          {/* Our dedicated team is available from Monday
          through Friday, 9 am to 5 pm (AET). */}
           We aim to respond to all inquiries
          within two business day.
        </Paragraph>
        <div className={`${PUBLIC_HEADING_TO_CONTENT_COMPACT_CLASS} w-full min-w-0`}>
          <FieldDropdown
            label="Please choose your inquiry type"
            variant="general"
            fullWidth
            value={selectedReason}
            onChange={(e) => setSelectedReason(e.value)}
            options={forms}
            optionLabel="name"
            optionValue="name"
            placeholder="──"
            className="custom-dropdown-paceholder"
          />
        </div>
        {selectedReason === "General inquiry" && (
          <div className={`mx-auto w-full ${PUBLIC_HEADING_TO_CONTENT_CLASS}`}>
            <GeneralInquiry />
          </div>
        )}
        {selectedReason === "Billing questions" && (
          <div className={`mx-auto w-full ${PUBLIC_HEADING_TO_CONTENT_CLASS}`}>
            <GeneralInquiry />
          </div>
        )}
        {selectedReason === "Technical support" && (
          <div className={`mx-auto w-full ${PUBLIC_HEADING_TO_CONTENT_CLASS}`}>
            <GeneralInquiry />
          </div>
        )}
        {selectedReason === "Feedback & suggestions" && (
          <div className={`mx-auto w-full ${PUBLIC_HEADING_TO_CONTENT_CLASS}`}>
            <GeneralInquiry />
          </div>
        )}
        {selectedReason === "Account issues" && (
          <div className={`mx-auto w-full ${PUBLIC_HEADING_TO_CONTENT_CLASS}`}>
            <GeneralInquiry />
          </div>
        )}
        {selectedReason === "Other" && (
          <div className={`mx-auto w-full ${PUBLIC_HEADING_TO_CONTENT_CLASS}`}>
            <GeneralInquiry />
          </div>
        )}
      </div>
    </>
  );
};

export default ContactUSForms;
